export default "__VITE_ASSET__DnJr4HI4__"